import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { Button, ButtonGroup, rem, Spacer } from 'design-system';
import Modal from 'utils/packages/Modal';
import { Tier } from 'features/premium/entities';
import { useAppSelector } from 'store/hooks';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import Links from 'utils/links';
import { formatPlural } from 'utils';
import { DEFAULT_UPGRADE_TEXT, selectShouldShowMicroModal, selectTryFor0Text, } from 'features/premium/selectors';
import { UpSellButtons, UpSellCard, } from 'features/premium/components/PremiumFeatureMicroModalContent';
const AccountConnectionsLimitModalContent = ({ currentLimit, }) => {
    const navigation = useMainStackNavigation();
    const userTier = useAppSelector(selectUserTier);
    const showMicroModal = useAppSelector(selectShouldShowMicroModal);
    const onUpgrade = useCallback(() => {
        Modal.hide(() => {
            navigation.navigate('EmmaProModal', {
                tier: Tier.pro,
                upsellTrial: false,
                benefitId: 'connections',
            });
        });
    }, []);
    const onPressMaybeLater = useCallback(() => {
        Modal.hide(() => {
            navigation.navigate('Logins');
        });
    }, []);
    const onPressWhy = useCallback(() => {
        Links.openKnownLink('whyDoINeedToSelectLogins');
    }, []);
    const tryFor0Text = useAppSelector(selectTryFor0Text);
    return (<View>
      <Text TextThin-14 Secondary style={styles.description} centered>
        {userTier === Tier.free
            ? `To add more bank connections you need to upgrade to Plus for 4, or Emma Pro or Ultimate for unlimited. Your plan currently supports ${currentLimit} free bank ${formatPlural('connection', 'connections', currentLimit)}.`
            : `To add unlimited bank connections, you need to upgrade to Emma Pro. Your plan currently supports ${currentLimit} bank connections.`}
      </Text>
      {showMicroModal === 'v2' ? (<>
          <Spacer h={16}/>
          <UpSellCard />
          <UpSellButtons onCancel={onPressMaybeLater} onContinue={onUpgrade}/>
        </>) : (<>
          <Text testID="whyButton" TextThin-14 Primary style={[styles.description, styles.buttonsGroup]} centered onPress={onPressWhy} suppressHighlighting>
            Why are bank connections limited?
          </Text>
          <ButtonGroup margins={false}>
            <Button brandReversed title="Manage connections" onPress={onPressMaybeLater} testID="manageBankLoginsButton"/>
            <Button brand title={tryFor0Text && tryFor0Text !== DEFAULT_UPGRADE_TEXT
                ? tryFor0Text
                : 'Continue'} onPress={onUpgrade} testID="viewUpgradeOptionsButton"/>
          </ButtonGroup>
        </>)}
    </View>);
};
const styles = StyleSheet.create({
    description: {
        marginTop: rem(8),
    },
    buttonsGroup: {
        marginBottom: rem(12),
    },
});
export default AccountConnectionsLimitModalContent;
